<template>
    <div
        v-if="data.length"
        class="navigation-top"
        role="navigation"
        aria-label="Top navigation"
        :class="{ 'navigation-top--index': isIndex }">
        <ul class="navigation-top__list">
            <li
                class="navigation-top__item"
                v-for="(item, index) in data"
                :key="index"
                :aria-current="item.active ? 'page' : null"
                :class="{ 'is-active': item.active }">
                <z-link
                    :href="item.link"
                    :title="item.name"
                    :aria-label="item.name"
                    size="m"
                    :underlined="false"
                    theme="white"
                    class="u-medium"
                >
                    <span v-html="item.name"></span>
                </z-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'navigation-top',
    props: {
        isIndex: Boolean
    },
    data() {
        return {
            data: this.$root.app.components.navigation.header
        }
    }
}
</script>

<style lang="scss">
.navigation-top {
    &__list {
        display: flex;
        justify-content: flex-end;
        margin: 0;
        gap: var(--spacer-s);
    }
}
</style>
